"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileConnectorBase = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
class MobileConnectorBase {
    constructor(deviceConnector, mobileHandler) {
        this.mobileCommunicator = new web_ui_framework_1.MobileCommunicator(deviceConnector, mobileHandler);
    }
}
exports.MobileConnectorBase = MobileConnectorBase;
//# sourceMappingURL=mobileConnectorBase.js.map